<template>
    <svg
        viewBox="0 0 55.80218 43.25896"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            :fill="textFill"
            d="M16.70585 0.0C16.70585 0.0 25.54137 0.0 25.54137 0.0C25.54137 0.0 41.71848 43.25896 41.71848 43.25896C41.71848 43.25896 33.63562 43.25896 33.63562 43.25896C33.63562 43.25896 20.77768 10.83683 20.77768 10.83683C20.77768 10.83683 17.08999 19.83126 17.08999 19.83126C17.08999 19.83126 19.11903 19.83126 19.11903 19.83126C19.11903 19.83126 22.2814 26.79801 22.2814 26.79801C19.65139 26.79801 17.02139 26.79801 14.39138 26.79801C14.39138 26.79801 8.57327 43.25896 8.57327 43.25896C8.57327 43.25896 0.0 43.25896 0.0 43.25896C0.0 43.25896 16.70585 0.0 16.70585 0.0"
            id="patha"
        />
        <path
            :fill="graphicFill"
            d="M31.47638 0.0C31.47638 0.0 39.11156 0.0 39.11156 0.0C39.11156 0.0 55.80218 43.25896 55.80218 43.25896C55.80218 43.25896 47.30475 43.25896 47.30475 43.25896C47.30475 43.25896 31.47638 0.0 31.47638 0.0"
            id="pathi"
        />
    </svg>
</template>

<script>
export default {
    name: "logo",
    data: () => ({}),
    computed: {
        graphicFill() {
            return this.$vuetify.theme.options.colors.orange.base; //this.$vuetify.theme.dark
            // ? this.$vuetify.theme.options.colors.red.base
            //  : this.$vuetify.theme.themes.light.primary;
        },
        textFill() {
            return this.$vuetify.theme.dark ? "white" : this.$vuetify.theme.options.colors.blue.darken4;
        }
    }
};
</script>
<style lang="stylus"></style>